import _implicitStylesheets from "./skillPackageFiles.css";
import _implicitScopedStylesheets from "./skillPackageFiles.scoped.css?scoped=true";
import _listingSkillFileBrowser from "listing/skillFileBrowser";
import _listingSkillFileViewer from "listing/skillFileViewer";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="empty-message${0}"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<div${"c0"} role="separator"${"a0:tabindex"} aria-orientation="vertical"${"a0:aria-label"}${"a0:aria-controls"}${"a0:aria-valuemin"} aria-valuemax="40"${"a0:aria-valuenow"}${2}></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, ncls: api_normalize_class_name, gid: api_scoped_id, b: api_bind, c: api_custom_element, h: api_element, ti: api_tab_index} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [!$cmp.hasSource ? api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.packageFilesEmpty))]) : null, $cmp.hasSource ? api_element("div", {
    className: api_normalize_class_name($cmp.twoPaneWrapperClass),
    style: $cmp.twoPaneStyle,
    key: 2
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.fileTreePaneClass),
    attrs: {
      "id": api_scoped_id("package-file-tree-pane"),
      "aria-hidden": $cmp.treeCollapsed,
      "inert": $cmp.treeCollapsed
    },
    key: 3
  }, [api_custom_element("listing-skill-file-browser", _listingSkillFileBrowser, {
    props: {
      "nodes": $cmp.nodes,
      "selectedPath": $cmp.selectedPath,
      "treeIsEmpty": $cmp.treeIsEmpty
    },
    key: 4,
    on: {
      "select": _m0 || ($ctx._m0 = api_bind($cmp.handleBrowserSelect)),
      "toggletree": _m1 || ($ctx._m1 = api_bind($cmp.handleToggleTree))
    }
  })]), api_static_fragment($fragment2, 6, [api_static_part(0, {
    on: {
      "pointerdown": _m4 || ($ctx._m4 = api_bind($cmp.handleSplitterPointerDown)),
      "keydown": _m5 || ($ctx._m5 = api_bind($cmp.handleSplitterKeyDown))
    },
    className: api_normalize_class_name($cmp.splitterClass),
    attrs: {
      "tabindex": api_tab_index($cmp.splitterTabIndex),
      "aria-label": $cmp.packageFilesHeading,
      "aria-controls": api_scoped_id("package-file-tree-pane"),
      "aria-valuemin": $cmp.splitterMinimum,
      "aria-valuenow": $cmp.splitterValue
    }
  }, null)]), $cmp.selectedPath ? api_custom_element("listing-skill-file-viewer", _listingSkillFileViewer, {
    props: {
      "selectedPath": $cmp.selectedPath,
      "selectedNode": $cmp.selectedNode,
      "selectedFileBody": $cmp.selectedFileBody,
      "isLoading": $cmp.isLoading,
      "hasError": $cmp.hasError,
      "treeCollapsed": $cmp.treeCollapsed,
      "source": $cmp.source
    },
    key: 7,
    on: {
      "toggletree": _m6 || ($ctx._m6 = api_bind($cmp.handleToggleTree)),
      "retry": _m7 || ($ctx._m7 = api_bind($cmp.handleRetry))
    }
  }) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7sklqp0l4ae";
tmpl.legacyStylesheetToken = "undefined-_skillPackageFiles";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
